import parse from 'html-react-parser';

import variables from './variables';
import translate from './translate';
import typingDelay from './function/typing-delay';
import typingBackspace from './function/typing-backspace';
import arrayJoin from './function/array-join';

export default (target = '', data = []) => {
  let components = [target];
  components = variables(components, data);
  components = arrayJoin(components, data);
  components = typingDelay(components);
  components = typingBackspace(components);
  components = translate(components, (obj) => parse(obj));
  return components;
};
